import React, { useEffect, useMemo, useRef, useState } from "react";
import './styles.css';
import Card from "../Card";
import DateTimeInput from "../DateTimeInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFloppyDisk, faXmark } from "@fortawesome/free-solid-svg-icons";
import FloatingActions, { FloatingAction } from "../FloatingActions";
import useRouter from "@/store/useRouter";
import { useShallow } from "zustand/shallow";
import { RouterStoreItemKey } from "@/store/useRouter/types";
import useAppData from "@/store/useAppData";
import axios from "axios";
import useDeviceType from "@/Utils/useDeviceType";
import FlightListComp from "../FlightList";
import DialogWindow from "../DialogWindow";
import { DeicingItem } from "../DeicingList/types";
import { StockItem } from "../StockingDeicingCard";
import { Stock, User } from "../UserSettings/types";
import { StockMovement } from "@/Utils/constants";

interface Option {
  value: string;
  label: string;
}

interface DeicingFormProps {
  weatherCodes?: Option[];
  operationCode?: string | null;
  onSubmit?: (data: DeicingFormData | null) => void;
}

export interface DeicingFormData {
  date: string;

  type1Start: string | null;
  type1End: string | null;
  type1Deice: DeicingFormItem[];
  //type1FluidConsumption: number | null;
  //fluidRatio: string | null;

  type2Start: string | null;
  type2End: string | null;
  type2Deice: DeicingFormItem[];
  //type2FluidConsumption: number | null;
  //fluid2Ratio: string | null;
  //waterConsumption: number | null;
  //water2Consumption: number | null;

  type3FluidConsumption: number | null;

  aircraft: string | null;
  stand: number | null;
  company?: number | null;
  aircraftType: string;
  aircraftRegistration: string;
  flightNumber: string;

  oat: number | null;
  wingTemperature: number | null;
  weatherCode: number | null;
  note: string;

  supervisor: string;
  checked: boolean;

  lastModified: string | null;
  modifiedBy: number | null;
  checkedBy: number | null;
  modifiedByName: string | null;
  checkedByName: string | null;
  repeatDeicingReason?: number | null;
  noteRepeatDeicing: string;
  oneTwoDeice: string | null;
  nextOperator: number | null;
}

export interface DeicingFormItem {
  type1FluidConsumption: number | null;
  fluidRatio: string | null;
  waterConsumption: number | null;
  note?: string | null;
}

const toLocalDate = (date: Date): string => {
  const offset = date.getTimezoneOffset();
  return new Date(date.getTime() - offset * 60_000)
    .toISOString()
    .slice(0, 10);
};

// const toLocalDateTime = (date: Date): string => {
//   const offset = date.getTimezoneOffset();
//   return new Date(date.getTime() - offset * 60_000)
//     .toISOString()
//     .slice(0, 16);
// };

// const toLocalDateTime = (timestamp: number): string => {
//   // const offset = date.getTimezoneOffset();
//   // return date.getTime() - offset * 60_000;

//   const date = new Date(timestamp);
//   const offset = date.getTimezoneOffset();

//   return new Date(date.getTime() - offset * 60_000)
//     .toISOString()
//     .slice(0, 16);
// };

export const toLocalDateTime = (value: string | Date): string => {
  const date = new Date(value);
  //const offset = date.getTimezoneOffset();

  return new Date(date.getTime() /*- offset * 60000*/)
    .toISOString()
    .slice(0, 16);
};

export const toLocalDateTimeOffset = (value: string | Date): string => {
  const date = new Date(value);
  const offset = date.getTimezoneOffset();

  return new Date(date.getTime() - offset * 60000)
    .toISOString()
    .slice(0, 16);
};

const initialFormData = (
  currentUserName: string,
  nextOperator: number | null
): DeicingFormData => ({
  date: toLocalDate(new Date()),

  type1Start: null,
  type1End: null,
  //type1FluidConsumption: null,
  //fluidRatio: null,

  type2Start: null,
  type2End: null,
  type1Deice: [{
    type1FluidConsumption: null,
    fluidRatio: null,
    waterConsumption: null,
    note: null
  }],
  type2Deice: [],
  //type2FluidConsumption: null,
  //waterConsumption: null,
  type3FluidConsumption: null,
  //fluid2Ratio: null,

  aircraft: null,
  stand: null,
  company: null,
  aircraftType: "",
  aircraftRegistration: "",
  flightNumber: "",

  oat: null,
  wingTemperature: null,
  weatherCode: null,
  note: "",

  supervisor: "",
  checked: false,

  lastModified: toLocalDateTimeOffset(new Date()),
  modifiedBy: null,
  checkedBy: null,
  modifiedByName: null,
  checkedByName: null,
  repeatDeicingReason: null,
  oneTwoDeice: "oneDeice",
  noteRepeatDeicing: "",
  nextOperator: nextOperator
});

interface aircraftItem {
  value: string;
  label: string;
  uniqueId?: string;
  stand?: null,
  company?: null,
  aircraftType?: "",
  aircraftRegistration?: "",
  flightNumber?: "",
}

export interface valueItem {
  value: string;
  label: string;
}

export interface FluidRationTemperature {
  temperature: number;
  oneStepFluidRatio: string;
  twoStepFirstFluidRatio: string;
  twoStepSecondFluidRatio: string;
}

const DeicingForm: React.FC<DeicingFormProps> = ({
  weatherCodes = [],
  operationCode,
  onSubmit,
}) => {

  const loggedUser = useAppData(state => state.user);
  const selectedDeicing = useAppData(state => state.selectedDeicing);
  const setSelectedDeicing = useAppData(state => state.setSelectedDeicing);
  const selectedStock = useAppData(state => state.selectedStock);

  const [stands, setStands] = useState<valueItem[]>([]);
  const [companies, setCompanies] = useState<valueItem[]>([]);
  const [repeatDeicingReason, setRepeatDeicingReason] = useState<valueItem[]>([]);
  const [aircraftList, setAircraftList] = useState<aircraftItem[]>([]);
  const [weatherList, setWeatherList] = useState<valueItem[]>([]);
  const deviceType = useDeviceType();
  const [oneTwoDeice, setOneTwoDeice] = useState<"oneDeice" | "twoDeice">("oneDeice");
  const [displayFlightList, setDisplayFlightList] = useState<boolean>(false);
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [fluidRatioTemperatureState, setFluidRatioTemperatureState] = useState<FluidRationTemperature | null>();
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const deicingIdRef = useRef<string | null>(operationCode === "repeatDeicing" ? null : selectedDeicing);
  const persistenceRef = useRef<Promise<string | null>>(Promise.resolve(null));
  const cancelledRef = useRef(false);
  const [type1FluidConsumptionStart, setType1FluidConsumptionStart] = useState<number>(0);
  const [type2FluidConsumptionStart, setType2FluidConsumptionStart] = useState<number>(0);
  const [waterConsumptionStart, setWaterConsumptionStart] = useState<number>(0);
  const [imatriculationFilter, setImatriculationFilter] = useState<string | null>(null);
  const [usersState, setUsersState] = React.useState<valueItem[]>([]);
  const secondOperator = useAppData(state => state.secondOperator);
  const setSecondOperator = useAppData(state => state.setSecondOperator);

  const [formData, setFormData] = useState<DeicingFormData>(() =>
    initialFormData(loggedUser?.name!, selectedStock?.twoOperators ? Number(secondOperator?.value) ?? null : null)
  );

  // const [leftFluidRation = "", rightFluidRatio = ""] = (formData?.fluidRatio ?? "").split("/");
  // const [leftFluid2Ration = "", rightFluid2Ratio = ""] = (formData?.fluid2Ratio ?? "").split("/");

  const router = useRouter(
    useShallow(state => ({
      go: state.go,
      history: state.history
    }))
  );

  useEffect(() => {

    if (selectedDeicing) {
      const init = async () => {
        await loadAirlines();
        await loadWeatherList();
        await loadRepeatDeicingReason();
        await loadStands();

        if (selectedStock?.twoOperators) {
          await loadUsers();
        }

        await loadDeicing(selectedDeicing);
      };

      init();
    } else {
      const init = async () => {
        await loadAirlines();
        await loadWeatherList();
        await loadStands();

        if (selectedStock?.twoOperators) {
          await loadUsers();
        }

        // const deicingId = await insertDeicing(formData);
        // setSelectedDeicing(deicingId);
      };

      init();
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (formData?.wingTemperature) {
      getFluidRatioTemperature(formData?.wingTemperature);
    } else if (formData?.oat) {
      getFluidRatioTemperature(formData?.oat);
    }
  }, [formData.oat, formData.wingTemperature]);

  const handleSubmit = async () => {

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    const deicingId = await updateTempFormData(formData, true);

    if (deicingId) {

      await removeDeicingItem(deicingId);

      if (formData?.type1Deice?.length) {
        for (const deicingItem of formData.type1Deice) {

          if (deicingItem?.fluidRatio && deicingItem?.type1FluidConsumption && deicingItem?.waterConsumption) {
            await insertDeicingItem(deicingItem, deicingId, "type1Deice");
          }
        }
      }

      if (formData?.type2Deice?.length) {
        for (const deicingItem of formData.type2Deice) {

          if (deicingItem?.fluidRatio && deicingItem?.type1FluidConsumption && deicingItem?.waterConsumption) {
            await insertDeicingItem(deicingItem, deicingId, "type2Deice");
          }
        }
      }

      await updateMainStockStockItems();

      router.go({ key: RouterStoreItemKey.LISTITEMS });
    }

    // onSubmit?.({
    //   ...formData,
    //   lastModified: toLocalDateTime(new Date()),
    //   modifiedBy: currentUserName,
    //   checkedBy: formData.checked ? currentUserName : "",
    // });
  };

  const updateTempFormData = (data: DeicingFormData, forceSave = false): Promise<string | null> => {
    // Serialize writes so Save and autosave share the same newly created record.
    const persistence = persistenceRef.current.catch(() => null).then(async () => {
      if (cancelledRef.current) {
        return null;
      }

      if (!deicingIdRef.current) {
        if (!forceSave && (!data?.aircraftRegistration?.trim() || !data?.flightNumber?.trim())) {
          return null;
        }

        const deicingId: string = await insertDeicing(data);
        deicingIdRef.current = deicingId;
        setSelectedDeicing(deicingId);
      } else {
        await updateDeicing(deicingIdRef.current, data);
      }

      return deicingIdRef.current;
    });

    persistenceRef.current = persistence;
    return persistence;
  };

  const actions: FloatingAction[] = [
    {
      key: "cancel",
      label: "Zrušit",
      //icon: <FontAwesomeIcon icon={faXmark} />,
      onClick: () => {
        cancelledRef.current = true;
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
          timeoutRef.current = null;
        }
        router.go({ key: RouterStoreItemKey.LISTITEMS });
        //onSubmit?.(null)
      },
    },
    {
      key: "save",
      label: "Uložit",
      //icon: <FontAwesomeIcon icon={faFloppyDisk} />,
      onClick: () => handleSubmit(),
    }
  ];

  const deicingDurationMinutes = useMemo(() => {
    const starts = [formData.type1Start, formData.type2Start]
      .filter(Boolean)
      .map(value => new Date(value ?? "").getTime())
      .filter(Number.isFinite);

    const ends = [formData.type1End, formData.type2End]
      .filter(Boolean)
      .map(value => new Date(value ?? "").getTime())
      .filter(Number.isFinite);

    if (!starts.length || !ends.length) {
      return 0;
    }

    const firstStart = Math.min(...starts);
    const lastEnd = Math.max(...ends);

    if (lastEnd < firstStart) {
      return 0;
    }

    return Math.round((lastEnd - firstStart) / 60_000);
  }, [
    formData.type1Start,
    formData.type1End,
    formData.type2Start,
    formData.type2End,
  ]);

  const totalConsumption = useMemo(() => {
    let sum = 0;

    formData.type1Deice?.forEach(item => {
      sum += Number(item.type1FluidConsumption) || 0;
    });

    formData.type2Deice?.forEach(item => {
      sum += Number(item.type1FluidConsumption) || 0;
    });

    return sum;
  }, [formData.type1Deice, formData.type2Deice]);

  const waterConsumption = useMemo(() => {

    let sum = 0;

    formData.type1Deice?.forEach(type1De => {
      sum += Number(type1De.waterConsumption) || 0;
    })

    formData.type2Deice?.forEach(type2De => {
      sum += Number(type2De.waterConsumption) || 0;
    })

    return sum;

    // return (
    //   Number(formData.type1FluidConsumption || 0) +
    //   Number(formData.type2FluidConsumption || 0)
    // );
  }, [formData.type1Deice, formData.type2Deice
  ]);

  // const waterConsumption = useMemo(() => {
  //   return (
  //     Number(formData.waterConsumption || 0) +
  //     Number(formData.water2Consumption || 0)
  //   );
  // }, [
  //   formData.waterConsumption,
  //   formData.water2Consumption,
  // ]);

  const deicingDate = useMemo(() => {
    const date = formData.type1Start ?? formData.type2Start;

    return date ? new Date(date) : undefined;
  }, [formData.type1Start, formData.type2Start]);

  const updateField = <K extends keyof DeicingFormData>(
    field: K,
    value: DeicingFormData[K]
  ) => {
    let updatedFormData;
    setFormData(previous => {
      updatedFormData = {
        ...previous,
        [field]: value,
        lastModified: toLocalDateTimeOffset(new Date()),
        modifiedBy: Number(loggedUser?.id!),
      }
      return updatedFormData;
    });

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => updateTempFormData(updatedFormData), 700);
  };

  const updateFieldNoUpdateTemp = <K extends keyof DeicingFormData>(
    field: K,
    value: DeicingFormData[K]
  ) => {
    setFormData(previous => {
      const updatedFormData = {
        ...previous,
        [field]: value,
        lastModified: toLocalDateTimeOffset(new Date()),
        modifiedBy: Number(loggedUser?.id!),
      }
      return updatedFormData;
    });
  };

  const setCurrentTime = (
    field: "type1Start" | "type1End" | "type2Start" | "type2End"
  ) => {
    updateField(field, toLocalDateTimeOffset(new Date()));
  };

  const handleCheckedChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const checked = event.target.checked;

    setFormData(previous => ({
      ...previous,
      checked,
      checkedBy: checked ? Number(loggedUser?.id!) : null,
      checkedByName: checked ? loggedUser?.name2 ?? null : null,
      lastModified: toLocalDateTimeOffset(new Date()),
      modifiedBy: Number(loggedUser?.id!),
    }));
  };

  const loadDeicing = async (id: string) => {
    try {
      const res = await (
        axios({
          method: "post",
          url: "api/deicing/get",
          data: {
            id: id
          }
        })
      );

      if (res?.data?.deicing?.length > 0) {

        if (operationCode === "repeatDeicing") {

          const deicing: DeicingFormData = res.data.deicing[0];

          const repeatDeicing: DeicingFormData = {
            date: "",
            type1Start: null,
            type1End: null,
            //type1FluidConsumption: null,
            //fluidRatio: null,
            type2Start: null,
            type2End: null,
            type1Deice: [{
              type1FluidConsumption: null,
              fluidRatio: null,
              waterConsumption: null,
              note: null
            }],
            type2Deice: [],
            //type2FluidConsumption: null,
            //waterConsumption: null,
            oat: null,
            wingTemperature: null,
            weatherCode: null,
            note: "",
            supervisor: "",
            checked: false,
            lastModified: null,
            modifiedBy: null,
            checkedBy: null,
            modifiedByName: null,
            checkedByName: null,

            aircraft: deicing.aircraft,
            aircraftType: deicing.aircraftType,
            aircraftRegistration: deicing.aircraftRegistration,
            flightNumber: deicing.flightNumber,
            stand: deicing.stand,
            //fluid2Ratio: null,
            type3FluidConsumption: null,
            oneTwoDeice: null,
            noteRepeatDeicing: "",
            nextOperator: selectedStock?.twoOperators ? deicing?.nextOperator ?? Number(secondOperator?.value) ?? null : null
          };

          setFormData(repeatDeicing);

          // const deicingId = await insertDeicing(repeatDeicing);
          // setSelectedDeicing(deicingId);

          return;
        }

        const deicing: DeicingFormData = res.data.deicing[0];
        deicing.type1Start = deicing?.type1Start ? toLocalDateTime(deicing.type1Start) : null;
        deicing.type1End = deicing?.type1End ? toLocalDateTime(deicing.type1End) : null;

        deicing.type2Start = deicing?.type2Start ? toLocalDateTime(deicing.type2Start) : null;
        deicing.type2End = deicing?.type2End ? toLocalDateTime(deicing.type2End) : null;

        const type1Deice = await getDeicingItem(id, "type1Deice");
        const type2Deice = await getDeicingItem(id, "type2Deice");

        if (type1Deice?.length > 0) {
          deicing.type1Deice = type1Deice;
        } else {
          deicing.type1Deice = [{
            type1FluidConsumption: null,
            fluidRatio: null,
            waterConsumption: null,
            note: null
          }];
        }

        if (type2Deice?.length > 0) {
          deicing.type2Deice = type2Deice;
        } else {
          deicing.type2Deice = [];
        }

        setFormData(deicing);

        if (deicing?.oneTwoDeice === "twoDeice") {
          setOneTwoDeice("twoDeice");
        }

        let sumType1FluidConsumption = 0;

        deicing.type1Deice?.forEach(item => {
          sumType1FluidConsumption += Number(item.type1FluidConsumption) || 0;
        });

        deicing.type2Deice?.forEach(item => {
          sumType1FluidConsumption += Number(item.type1FluidConsumption) || 0;
        });

        setType1FluidConsumptionStart(sumType1FluidConsumption);

        let sumWaterConsumption = 0;

        deicing.type1Deice?.forEach(item => {
          sumWaterConsumption += Number(item.waterConsumption) || 0;
        });

        deicing.type2Deice?.forEach(item => {
          sumWaterConsumption += Number(item.waterConsumption) || 0;
        });

        setWaterConsumptionStart(sumWaterConsumption);

        setType2FluidConsumptionStart(deicing?.type3FluidConsumption || 0);
      }
    } catch (err) {
      throw err;
    }
  }

  const updateMainStockStockItems = async () => {
    const mainStock: Stock = await getMainStock();
    const stockItemsMainStock = await getStockItems(mainStock.id);

    await Promise.all(
      stockItemsMainStock
        .filter(stockItem => stockItem.name != "IBC kontejner")
        .map(async stockItem => {
          const fluidConsumption = stockItem.name === "Kapalina I" ? (totalConsumption - type1FluidConsumptionStart) : stockItem.name === "Kapalina II" ? ((formData.type3FluidConsumption || 0) - type2FluidConsumptionStart) : (waterConsumption - waterConsumptionStart);

          if (fluidConsumption > 0) {
            await updateStockItemDecrement(stockItem.id, fluidConsumption);
            await stockMovement(mainStock.id, stockItem.id, String(StockMovement.Issue), fluidConsumption, loggedUser!.id);
            await stockMovement(selectedStock.id, stockItem.id, String(StockMovement.StockIn), fluidConsumption, loggedUser!.id);
            await stockMovement(selectedStock.id, stockItem.id, String(StockMovement.Issue), fluidConsumption, loggedUser!.id);

            if (stockItem.autofill) {
              await updateStockItemIncrement2(stockItem.id, fluidConsumption);
              await stockMovement(mainStock.id, stockItem.id, String(StockMovement.StockIn), fluidConsumption, loggedUser!.id);
            }
          } else if (!stockItem.autofill && fluidConsumption != 0) {
            await updateStockItemIncrement2(stockItem.id, Math.abs(fluidConsumption));
            await stockMovement(mainStock.id, stockItem.id, String(StockMovement.StockIn), Math.abs(fluidConsumption), loggedUser!.id);
          }
        })
    );
  }

  const stockMovement = async (stockId: string, stockItemId: string, stockMovementId: string, quantity: number, userId: string) => {
    try {
      const res = await axios({
        method: "post",
        url: "/api/log/stockMoveOdmraz",
        data: {
          stockId: stockId,
          stockItemId: stockItemId,
          quantity: quantity,
          stockMovementId: stockMovementId,
          userId: userId,
          odmraz: true,
          date: toLocalDateTimeOffset(new Date())
        },
      });

      return res.data.id;
    } catch (err) {
      console.error("Failed to make stock movement item", err);
      throw err;
    }
  };

  const getMainStock = async () => {

    try {
      const res = await (
        axios({
          method: "post",
          url: "api/stock/getAll",
          data: {
            mainStock: true
          }
        })
      );

      if (!res?.data?.stocks?.length || res?.data?.stocks?.length === 0) {
        return null;
      }

      return res?.data?.stocks[0];

    } catch (err) {
      throw err;
    }
  }

  const getStockItems = async (stockId: string) => {
    try {
      const res = await (
        axios({
          method: "post",
          url: "api/stockitem/getAll",
          data: {
            start: 0,
            end: 100,
            stockId: stockId
          }
        })
      );

      return res.data.stocksItems;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  const updateStockItemDecrement = async (stockItemId: string, qauntity: number) => {
    try {
      const res = await axios({
        method: "post",
        url: "/api/stockitem/updateDecrement",
        data: {
          id: stockItemId,
          quantity: qauntity
        },
      });

      return res.data.id;
    } catch (err) {
      console.error("Failed to update stock item decrement", err);
      throw err;
    }
  };

  const updateStockItemIncrement2 = async (stockItemId: string, qauntity: number) => {
    try {
      const res = await axios({
        method: "post",
        url: "/api/stockitem/updateIncrement2",
        data: {
          id: stockItemId,
          quantity: qauntity
        },
      });

      return res.data.id;
    } catch (err) {
      console.error("Failed to update stock item decrement", err);
      throw err;
    }
  };

  const loadAirlines = async () => {
    try {
      const res = await (
        axios({
          method: "post",
          url: "api/airline/getAll"
        })
      );

      if (res?.data?.airlines?.length > 0) {

        setCompanies(res?.data?.airlines.map(airline => ({ value: airline.id, label: airline.name })));
      }
    } catch (err) {
      throw err;
    }
  }

  const loadStands = async () => {
    try {
      const res = await (
        axios({
          method: "post",
          url: "api/stand/getAll"
        })
      );

      if (res?.data?.stands?.length > 0) {

        setStands(res?.data?.stands.map(stand => ({ value: stand.id, label: stand.sign })));
      }
    } catch (err) {
      throw err;
    }
  }

  const loadUsers = async () => {
    try {
      const res = await (
        axios({
          method: "post",
          url: "api/appuser/getAllByModuleCode",
          data: {
            moduleCode: "ODMRAZ"
          }
        })
      );

      setUsersState(res.data.users?.filter(user => user?.id != loggedUser?.id && user?.userrole?.includes("operator"))?.map(user => ({ value: user.id, label: user.name })));
    } catch (err) {
      throw err;
    }
  }

  const loadWeatherList = async () => {
    try {
      const res = await (
        axios({
          method: "post",
          url: "api/weather/getAll"
        })
      );

      if (res?.data?.weather?.length > 0) {

        setWeatherList(res?.data?.weather.map(weather => ({ value: weather.id, label: weather.name })));
      }
    } catch (err) {
      throw err;
    }
  }

  const getFlight = async (aircraftRegistration: string) => {
    try {
      const res = await (
        axios({
          method: "post",
          url: "api/flightList/get",
          data: {
            aircraftRegistration: aircraftRegistration
          }
        })
      );

      return res.data.flight
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  const getDeicingItem = async (deicingId: string, field: string) => {
    try {
      const res = await (
        axios({
          method: "post",
          url: "api/deicingitem/get",
          data: {
            deicingId: deicingId,
            field: field
          }
        })
      );

      return res.data.deicing_item;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  const loadRepeatDeicingReason = async () => {
    try {
      const res = await (
        axios({
          method: "post",
          url: "api/repeatdeicingreason/getAll"
        })
      );

      if (res?.data?.repeatDeicingReason?.length > 0) {

        setRepeatDeicingReason(res?.data?.repeatDeicingReason.map(repeatdeicingReason => ({ value: repeatdeicingReason.id, label: repeatdeicingReason.name })));
      }
    } catch (err) {
      throw err;
    }
  }

  const insertDeicing = async (deicing: DeicingFormData) => {
    try {
      const res = await (
        axios({
          method: "post",
          url: "api/deicing/insert",
          data: {
            ...deicing,
            stockId: selectedStock?.id,
            oneTwoDeice: oneTwoDeice,
            date: deicingDate,
            lastModified: toLocalDateTimeOffset(new Date()),
            modifiedBy: Number(loggedUser?.id!),
            operator1: Number(loggedUser?.id!),
            // nextOperator: selectedStock?.twoOperators ? deicing?.nextOperator ?? secondOperator?.value ?? null : null
            // type1Start: deicing.type1Start ? new Date(deicing.type1Start) : null,
            // type1End: deicing.type1End ? new Date(deicing.type1End) : null
          }
        })
      );

      return res.data.id;
    } catch (err) {
      throw err;
    }
  }

  const removeDeicingItem = async (deicingId: string) => {
    try {
      await (
        axios({
          method: "post",
          url: "api/deicingitem/remove",
          data: {
            deicing: deicingId
          }
        })
      );

    } catch (err) {
      throw err;
    }
  }

  const updateDeicing = async (id: string, deicing: DeicingFormData) => {
    try {
      const res = await (
        axios({
          method: "post",
          url: "api/deicing/update",
          data: {
            id: id,
            ...deicing,
            oneTwoDeice: oneTwoDeice,
            date: deicingDate,
            lastModified: toLocalDateTimeOffset(new Date()),
            modifiedBy: Number(loggedUser?.id!)
          }
        })
      );

      return res.data.id;
    } catch (err) {
      throw err;
    }
  }

  const insertDeicingItem = async (deicingItem: DeicingFormItem, deicingId: string, field: string) => {
    try {
      const res = await (
        axios({
          method: "post",
          url: "api/deicingitem/insert",
          data: {
            ...deicingItem,
            deicing: deicingId,
            field: field
          }
        })
      );

      return res.data.id;
    } catch (err) {
      throw err;
    }
  }

  const getFluidRatioTemperature = async (temperature: number) => {
    try {
      const res = await (
        axios({
          method: "post",
          url: "api/fluidratiotemperature/get",
          data: {
            temperature: temperature > 3 ? 3 : temperature
          }
        })
      );

      if (res?.data?.fluidratioTemperature?.length > 0) {
        setFluidRatioTemperatureState(res?.data?.fluidratioTemperature[0]);
      }
    } catch (err) {
      throw err;
    }
  }

  const getAirline = async (airlineCode: string) => {
    try {
      const res = await (
        axios({
          method: "post",
          url: "api/airline/get",
          data: {
            airlineCode: airlineCode
          }
        })
      );

      return res.data.airline
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  const updateAircraftData = (e) => {

    updateField(
      "aircraftRegistration",
      e.target.value
    )
  }

  const handleFlightList = () => {
    setDisplayFlightList(true);
  };

  const addDeiceItemType1 = () => {
    setFormData(prevState => {
      return {
        ...prevState,
        type1Deice: [...prevState.type1Deice || [], {
          type1FluidConsumption: null,
          fluidRatio: null,
          waterConsumption: null,
          note: null
        }]
      }
    })
  }

  const addDeiceItemType2 = () => {
    setFormData(prevState => {
      return {
        ...prevState,
        type2Deice: [...prevState.type2Deice || [], {
          type1FluidConsumption: null,
          fluidRatio: null,
          waterConsumption: null,
          note: null
        }]
      }
    })
  }

  const loadFlight = async () => {
    if (formData?.aircraftRegistration) {
      const flight = await getFlight(formData?.aircraftRegistration);

      if (flight?.length > 0) {

        // const airline = await getAirline(flight[0]?.company);
        // flight[0].company = airline?.id;

        if (flight?.length === 1) {

          const updatedFormData = {
            ...formData,
            company: flight[0]?.company,
            flightNumber: flight[0]?.flight_number,
            aircraftRegistration: flight[0]?.aircraft_registration,
            aircraftType: flight[0]?.aircraft_type,
            ...(flight[0]?.stand ? { stand: flight[0]?.stand } : {})
          };

          setFormData(updatedFormData);
          updateTempFormData(updatedFormData);

          // let updatedFormData;
          // setFormData(prevState => {
          //   updatedFormData = {
          //     ...prevState,
          //     company: flight[0]?.company,
          //     flightNumber: flight[0]?.flight_number,
          //     aircraftRegistration: flight[0]?.aircraft_registration,
          //     aircraftType: flight[0]?.aircraft_type,
          //     stand: flight[0]?.stand
          //   };

          //   return updatedFormData;
          // });

          // updateTempFormData(updatedFormData);
        } else {
          const formatImatriculation = formData?.aircraftRegistration?.trim().replace(/-/g, "");
          setImatriculationFilter(formatImatriculation);
          handleFlightList();
        }
      } else {
        setShowDialog(true);
      }
    } else {
      handleFlightList();
    }
  };

  const onClickBackFlightList = () => {
    setDisplayFlightList(false);
    setImatriculationFilter(null);
  }

  const onClickSelectFlightFlightList = (flight: any) => {
    setDisplayFlightList(false);
    setImatriculationFilter(null);

    const updatedFormData = {
      ...formData,
      company: flight?.company,
      flightNumber: flight?.flight_number,
      aircraftRegistration: flight?.aircraft_registration,
      aircraftType: flight?.aircraft_type,
      ...(flight?.stand ? { stand: flight?.stand } : {})
    };

    setFormData(updatedFormData);
    updateTempFormData(updatedFormData);

    // let updatedFormData;

    // setFormData(prevState => {

    //   updatedFormData = {
    //     ...prevState,
    //     company: flight?.company,
    //     flightNumber: flight?.flight_number,
    //     aircraftRegistration: flight?.aircraft_registration,
    //     aircraftType: flight?.aircraft_type,
    //     stand: flight?.stand
    //   };

    //   return updatedFormData;
    // });

    // updateTempFormData(updatedFormData);
  }

  const fluidRatioVsFluidConsumption = (
    fluidRatio: string,
    fluidConsumption: number,
    waterConsumption: number,
    toleranceDown = 0,
    toleranceUp = 7
  ): boolean => {
    const [fluidRatioValue, waterRatioValue] = fluidRatio
      .split("/")
      .map(Number);

    const fluid = Number(fluidConsumption);
    const water = Number(waterConsumption);

    if (
      !Number.isFinite(fluidRatioValue) ||
      !Number.isFinite(waterRatioValue) ||
      !Number.isFinite(fluid) ||
      !Number.isFinite(water) ||
      fluidRatioValue + waterRatioValue === 0 ||
      fluid + water === 0
    ) {
      return false;
    }

    const expectedFluidPercent =
      (fluidRatioValue / (fluidRatioValue + waterRatioValue)) * 100;

    const actualFluidPercent =
      (fluid / (fluid + water)) * 100;

    const min = expectedFluidPercent - toleranceDown;
    const max = expectedFluidPercent + toleranceUp;

    return actualFluidPercent >= min && actualFluidPercent <= max;
  };

  const checkFluidMaxRatio = (
    fluidRatio: string | null
  ): boolean => {

    if (fluidRatio) {
      const fluiRatio = fluidRatio.split("/")[0];

      if (fluiRatio) {
        return Number(fluidRatio.split("/")[0]) <= 69;
      }
    }

    return true;
  };

  const checkFluidRatioVsTemperature = (
    fluidRatio: string | null,
    oneTwoStepFluidratio: "oneStepFluidRatio" | "twoStepFirstFluidRatio" | "twoStepSecondFluidRatio"
  ): boolean => {

    if (!fluidRatioTemperatureState || !fluidRatio)
      return true;

    if (oneTwoStepFluidratio === "oneStepFluidRatio") {
      return fluidRatio === fluidRatioTemperatureState?.oneStepFluidRatio || Number(fluidRatio.split("/")[0]) > Number(fluidRatioTemperatureState?.oneStepFluidRatio?.split("/")[0]);
    }

    if (oneTwoStepFluidratio === "twoStepFirstFluidRatio") {
      return fluidRatio === fluidRatioTemperatureState?.twoStepFirstFluidRatio || Number(fluidRatio.split("/")[0]) > Number(fluidRatioTemperatureState?.twoStepFirstFluidRatio?.split("/")[0]);
    }

    if (oneTwoStepFluidratio === "twoStepSecondFluidRatio") {
      return fluidRatio === fluidRatioTemperatureState?.twoStepSecondFluidRatio || Number(fluidRatio.split("/")[0]) > Number(fluidRatioTemperatureState?.twoStepSecondFluidRatio?.split("/")[0]);;
    }

    return true;
  };

  const updateDeiceItem = <K extends keyof DeicingFormItem>(
    type: "type1Deice" | "type2Deice",
    index: number,
    field: K,
    value: DeicingFormItem[K]
  ) => {
    setFormData(prev => ({
      ...prev,
      [type]: prev[type].map((item, i) =>
        i === index
          ? { ...item, [field]: value }
          : item
      ),
      lastModified: toLocalDateTimeOffset(new Date()),
      modifiedBy: Number(loggedUser?.id!),
    }));
  };

  if (displayFlightList) {
    return (
      <FlightListComp
        onClickBack={onClickBackFlightList}
        onClickSelect={onClickSelectFlightFlightList}
        imatriculationFilter={imatriculationFilter}
      />
    );
  }

  return <>
    {showDialog && <DialogWindow
      displayDialog={showDialog}
      setDisplayDialog={setShowDialog}
      title={"Nenalezen žádný let se zadanou imatrikulací. Let vyberte ze seznamu letů nebo zadejte ručně."}
      cancelText={"OK"}
    />}
    <Card
      title="Odmraz"
      displayLogo={false}
      displaySelectedStock={false}
    >
      <form className="deicing-form">

        <div className="form-section-vozidlo">Vozidlo: {selectedStock?.name}</div>

        {/* {selectedStock?.twoOperators && secondOperator?.label && <div className="form-section-vozidlo">Druhý operátor: {secondOperator?.label}</div>} */}

        {selectedStock?.twoOperators && <section className="form-section">
          <h3>Druhý operátor</h3>
          <div className="form-grid">
            <SelectField
              label=""
              value={formData.nextOperator ?? ""}
              options={usersState}
              onChange={value => {
                updateFieldNoUpdateTemp("nextOperator", value ? Number(value) : null);

                if (value) {
                  const selectedUser = usersState.find(user => Number(user.value) === Number(value));

                  if (selectedUser) {
                    setSecondOperator(selectedUser);
                  }
                }
              }}
            />
          </div>
        </section>}

        {(operationCode === "repeatDeicing" || (selectedDeicing && formData.repeatDeicingReason)) && <section className="form-section">
          <h3>Opakovaný odmraz</h3>

          <div className="form-grid">
            <SelectField
              label="Důvod opakování"
              value={formData.repeatDeicingReason}
              options={repeatDeicingReason}
              onChange={value => updateField("repeatDeicingReason", Number(value))}
            />
          </div>

          <div />

          <label className="wheatherConditions">
            Poznámka
            <textarea
              rows={4}
              value={formData.noteRepeatDeicing}
              onChange={event => updateField("noteRepeatDeicing", event.target.value)}
            />
          </label>
        </section>}

        <section className="form-section">
          <h3>Letadlo</h3>

          <div className="form-grid">
            <label>
              Imatrikulace letadla

              <div className="input-with-button">
                <input
                  type="text"
                  value={formData.aircraftRegistration}
                  onChange={updateAircraftData}
                />

                <button
                  type="button"
                  onClick={() => loadFlight?.()}
                >
                  Vyhledat let
                </button>
              </div>
            </label>

            {/* <SelectField
              label="Stojánka"
              value={formData.stand}
              options={stands}
              onChange={value => updateField("stand", Number(value))}
            /> */}

            <SelectField
              label="Stojánka"
              value={formData.stand}
              options={stands}
              onChange={value => updateField("stand", Number(value))}
            />
            {/* <input
                type="text"
                value={formData.stand}
                onChange={event =>
                  updateField("stand", event.target.value)
                }
              /> */}

            <SelectField
              label="Společnost"
              value={formData.company}
              options={companies}
              onChange={value => updateField("company", Number(value))}
            />

            <label>
              Typ letadla
              <input
                type="text"
                value={formData.aircraftType}
                onChange={event =>
                  updateField("aircraftType", event.target.value)
                }
              />
            </label>

            <label>
              Číslo letu
              <input
                type="text"
                value={formData.flightNumber}
                onChange={event =>
                  updateField(
                    "flightNumber",
                    event.target.value
                  )
                }
              />
            </label>

            {/* <div className="form-action-field">
              <button
                type="button"
                className="form-action-link"
                onClick={handleFlightList}
              >
                Seznam letů
              </button>
            </div> */}
            {/* <div className="form-action-field">
              <button
                type="button"
                className="form-action-button"
                onClick={handleFlightList}
              >
                Seznam letů
              </button>
            </div> */}
          </div>
        </section>

        <section className="form-section">
          <h3>Podmínky</h3>

          <div className="form-grid">
            <NumberField
              label="OAT [°C]"
              value={formData.oat}
              onChange={value => updateField("oat", value)}
            />

            <NumberField
              label="Teplota křídel [°C] - nastavená teplota ve vozidle"
              value={formData.wingTemperature}
              onChange={value => updateField("wingTemperature", value)}
            />
          </div>

          {formData?.oat && formData?.wingTemperature && formData?.oat < formData?.wingTemperature && <div className="validation-warning">
            ⚠ Teplota OAT musí být vyšší nebo rovna teplotě křídel.
          </div>}

          <label className="wheatherConditions">
            Poznámka
            <textarea
              rows={4}
              value={formData.note}
              onChange={event => updateField("note", event.target.value)}
            />
          </label>
        </section>

        {/* {selectedDeicing && !operationCode && loggedUser?.userrole === "kontrola" && <section className="form-section">
          <h3>Kontrola</h3>

          <div className="form-grid">
            <label className="checkbox-field">
              <input
                type="checkbox"
                checked={formData.checked}
                disabled={true}
                onChange={handleCheckedChange}
              />
              Zkontrolováno
            </label>

            <label>
              Zkontroloval
              <input type="text" disabled={true} value={formData?.checkedByName ?? undefined} readOnly />
            </label>
          </div>
        </section>} */}

        <section className="form-section">
          <h3>Stupeň odmrazování</h3>
          <div className="toggle">
            <button
              type="button"
              className={oneTwoDeice === "oneDeice" ? "active" : ""}
              onClick={() => setOneTwoDeice("oneDeice")}
            >
              Jednostupňové
            </button>

            <button
              type="button"
              className={oneTwoDeice === "twoDeice" ? "active" : ""}
              onClick={() => setOneTwoDeice("twoDeice")}
            >
              Dvoustupňové
            </button>
          </div>
        </section>

        <section className="form-section">
          <h3>První stupeň</h3>

          <div className="form-grid">
            <DateTimeField
              label="Začátek"
              value={formData.type1Start}
              onChange={value => updateField("type1Start", value)}
              onSetCurrentTime={() => setCurrentTime("type1Start")}
            />

            <DateTimeField
              label="Konec"
              value={formData.type1End}
              onChange={value => updateField("type1End", value)}
              onSetCurrentTime={() => setCurrentTime("type1End")}
            />

            {/* <NumberField
              label="Poměr kapalin"
              value={formData.fluidRatio}
              min={0}
              max={100}
              onChange={value => updateField("fluidRatio", value)}
            /> */}
          </div>

          <div className="form-grid-item deice-item">
            {formData.type1Deice.map((typeDeice, index) => {

              const [leftFluidRation = "", rightFluidRatio = ""] = (typeDeice.fluidRatio ?? "").split("/");

              return <>
                <label>
                  Poměr kapalin v % (kapalina / voda)
                  <div className="ratio-input">
                    <input
                      type="number"
                      inputMode="numeric"
                      min={0}
                      value={leftFluidRation}
                      onChange={event => {
                        const leftRatio = Number(event.target.value);
                        const rightRatio = 100 - leftRatio;
                        updateDeiceItem("type1Deice", index, "fluidRatio", `${event.target.value}/${rightRatio}`)
                        //typeDeice.fluidRatio = `${event.target.value}/${rightFluidRatio}`
                        //updateField("fluidRatio", `${event.target.value}/${rightFluidRatio}`)
                      }}
                    />
                    <span>/</span>
                    <input
                      type="number"
                      inputMode="numeric"
                      value={rightFluidRatio}
                      disabled={true}
                    // onChange={event =>
                    //   //updateDeiceItem("type1Deice", index, "fluidRatio", `${leftFluidRation}/${event.target.value}`)
                    //   //typeDeice.fluidRatio = `${leftFluidRation}/${event.target.value}`
                    //   //updateField("fluidRatio", `${leftFluidRation}/${event.target.value}`)
                    // } 
                    />
                  </div>
                </label>

                <NumberField
                  label="Spotřeba kapaliny I [litr]"
                  value={typeDeice.type1FluidConsumption}
                  min={0}
                  onChange={value =>
                    updateDeiceItem("type1Deice", index, "type1FluidConsumption", value)
                    //typeDeice.type1FluidConsumption = value
                    //updateField("type1FluidConsumption", value)
                  }
                />

                <NumberField
                  label="Spotřeba vody [litr]"
                  value={typeDeice.waterConsumption}
                  min={0}
                  onChange={value =>
                    updateDeiceItem("type1Deice", index, "waterConsumption", value)
                    //typeDeice.waterConsumption = value
                    //updateField("waterConsumption", value)
                  }
                />

                <label>
                  Poznámka
                  <textarea
                    rows={4}
                    value={typeDeice.note ?? undefined}
                    onChange={event => updateDeiceItem("type1Deice", index, "note", event.target.value)}
                  />
                </label>

                <div>
                  {typeDeice.fluidRatio && typeDeice.type1FluidConsumption && typeDeice.waterConsumption &&
                    !fluidRatioVsFluidConsumption(typeDeice.fluidRatio, typeDeice.type1FluidConsumption, typeDeice.waterConsumption) &&
                    <div className="validation-warning">
                      ⚠ Spotřeba kapaliny a vody neodpovídá zadanému poměru.
                    </div>
                  }
                  {!checkFluidRatioVsTemperature(typeDeice.fluidRatio, oneTwoDeice === "oneDeice" ? "oneStepFluidRatio" : "twoStepFirstFluidRatio") &&
                    <div className="validation-warning">
                      ⚠ Poměr kapaliny a vody neodpovídá zadané teplotě {formData?.wingTemperature ?? formData?.oat} °C.
                    </div>
                  }
                  {!checkFluidMaxRatio(typeDeice.fluidRatio) &&
                    <div className="validation-warning">
                      ⚠ Kapalina nemůže tvořit více jak 69% z celkového množství.
                    </div>
                  }
                </div>
              </>
            })}
          </div>

          <div>
            <button
              type="button"
              className="form-action-button-plus"
              onClick={addDeiceItemType1}
            >
              +
            </button>
          </div>
        </section>

        {oneTwoDeice === "twoDeice" && <section className="form-section">
          <h3>Druhý stupeň</h3>

          <div className="form-grid">
            <DateTimeField
              label="Začátek"
              value={formData.type2Start}
              onChange={value => updateField("type2Start", value)}
              onSetCurrentTime={() => setCurrentTime("type2Start")}
            />

            <DateTimeField
              label="Konec"
              value={formData.type2End}
              onChange={value => updateField("type2End", value)}
              onSetCurrentTime={() => setCurrentTime("type2End")}
            />

            <NumberField
              label="Spotřeba kapaliny II [litr]"
              value={formData.type3FluidConsumption}
              min={0}
              onChange={value => {
                updateField("type3FluidConsumption", value);

                setFormData(prevState => {
                  return {
                    ...prevState,
                    type2Deice: []
                  }
                })
              }
              }
              readOnly={!!formData.type2Deice?.find(typeDeice => typeDeice.type1FluidConsumption || typeDeice.fluidRatio || typeDeice.waterConsumption)}
            />

            <div />

            {/* <label>
              Poměr kapalin
              <div
                className="ratio-input">
                <input
                  type="number"
                  inputMode="numeric"
                  value={leftFluid2Ration}
                  onChange={event =>
                    updateField("fluid2Ratio", `${event.target.value}/${rightFluid2Ratio}`)
                  }
                  readOnly={!!formData.type3FluidConsumption}
                />
                <span>/</span>
                <input
                  type="number"
                  inputMode="numeric"
                  value={rightFluid2Ratio}
                  onChange={event =>
                    updateField("fluid2Ratio", `${leftFluid2Ration}/${event.target.value}`)
                  }
                  readOnly={!!formData.type3FluidConsumption}
                />
              </div>
            </label>

            <NumberField
              label="Spotřeba kapaliny I [litr]"
              value={formData.type2FluidConsumption}
              min={0}
              onChange={value =>
                updateField("type2FluidConsumption", value)
              }
              readOnly={!!formData.type3FluidConsumption}
            />

            <NumberField
              label="Spotřeba vody [litr]"
              value={formData.water2Consumption}
              min={0}
              onChange={value => updateField("water2Consumption", value)}
              readOnly={!!formData.type3FluidConsumption}
            /> */}
          </div>

          <div className="form-grid-item deice-item">
            {formData.type2Deice.map((typeDeice, index) => {

              const [leftFluidRation = "", rightFluidRatio = ""] = (typeDeice.fluidRatio ?? "").split("/");

              return <>
                <label>
                  Poměr kapalin v % (kapalina / voda)
                  <div className="ratio-input">
                    <input
                      type="number"
                      inputMode="numeric"
                      min={0}
                      value={leftFluidRation}
                      onChange={event => {

                        const value = `${event.target.value}/${rightFluidRatio}`;
                        updateDeiceItem("type2Deice", index, "fluidRatio", value === "/" ? null : value);

                        if (event.target.value) {
                          const leftRatio = Number(event.target.value);
                          const rightRatio = 100 - leftRatio;
                          updateDeiceItem("type2Deice", index, "fluidRatio", `${event.target.value}/${rightRatio}`)
                        } else {
                          updateDeiceItem("type2Deice", index, "fluidRatio", null);
                        }
                      }
                        //typeDeice.fluidRatio = `${event.target.value}/${rightFluidRatio}`
                        //updateField("fluidRatio", `${event.target.value}/${rightFluidRatio}`)
                      }
                      readOnly={!!formData.type3FluidConsumption}
                    />
                    <span>/</span>
                    <input
                      type="number"
                      inputMode="numeric"
                      disabled={true}
                      value={rightFluidRatio}
                      // onChange={event => {

                      //   const value = `${leftFluidRation}/${event.target.value}`;
                      //   updateDeiceItem("type2Deice", index, "fluidRatio", value === "/" ? null : value);
                      // }
                      //   //typeDeice.fluidRatio = `${leftFluidRation}/${event.target.value}`
                      //   //updateField("fluidRatio", `${leftFluidRation}/${event.target.value}`)
                      // }
                      readOnly={!!formData.type3FluidConsumption}
                    />
                  </div>
                </label>

                <NumberField
                  label="Spotřeba kapaliny I [litr]"
                  value={typeDeice.type1FluidConsumption}
                  min={0}
                  onChange={value =>
                    updateDeiceItem("type2Deice", index, "type1FluidConsumption", value)
                    //typeDeice.type1FluidConsumption = value
                    //updateField("type1FluidConsumption", value)
                  }
                  readOnly={!!formData.type3FluidConsumption}
                />

                <NumberField
                  label="Spotřeba vody [litr]"
                  value={typeDeice.waterConsumption}
                  min={0}
                  onChange={value =>
                    updateDeiceItem("type2Deice", index, "waterConsumption", value)
                    //typeDeice.waterConsumption = value
                    //updateField("waterConsumption", value)
                  }
                  readOnly={!!formData.type3FluidConsumption}
                />

                <label>
                  Poznámka
                  <textarea
                    rows={4}
                    value={typeDeice.note ?? undefined}
                    onChange={event => updateDeiceItem("type2Deice", index, "note", event.target.value)}
                    disabled={!!formData.type3FluidConsumption}
                  />
                </label>

                <div>
                  {typeDeice.fluidRatio && typeDeice.type1FluidConsumption && typeDeice.waterConsumption &&
                    !fluidRatioVsFluidConsumption(typeDeice.fluidRatio, typeDeice.type1FluidConsumption, typeDeice.waterConsumption) &&
                    <div className="validation-warning">
                      ⚠ Spotřeba kapaliny a vody neodpovídá zadanému poměru.
                    </div>
                  }

                  {!checkFluidRatioVsTemperature(typeDeice.fluidRatio, "twoStepSecondFluidRatio") &&
                    <div className="validation-warning">
                      ⚠ Poměr kapaliny a vody neodpovídá zadané teplotě {formData?.wingTemperature ?? formData?.oat} °C.
                    </div>
                  }
                </div>
              </>
            })}
          </div>

          <div>
            <button
              type="button"
              className="form-action-button-plus-second-level"
              onClick={addDeiceItemType2}
              disabled={formData.type3FluidConsumption === null ? false : true}
            >
              +  Druhý stupeň kapalinou I
            </button>
          </div>

        </section>}

        {/* {selectedDeicing && !operationCode && loggedUser?.userrole !== "kontrola" && <section className="form-section">
          <h3>Kontrola</h3>

          <div className="form-grid">
            <SelectField
              label="Počasí"
              value={formData.weatherCode}
              options={weatherList}
              disabled={true}
              onChange={value => updateField("weatherCode", Number(value))}
            />

            <div />

            <label className="checkbox-field">
              <input
                type="checkbox"
                checked={formData.checked}
                onChange={handleCheckedChange}
                disabled={true}
              />
              Zkontrolováno
            </label>

            <label>
              Zkontroloval
              <input type="text" disabled={true} value={formData?.checkedByName ?? undefined} readOnly />
            </label>
          </div>
        </section>} */}

        <section className="form-section">
          <h3>Souhrn</h3>

          <div className="form-grid">

            <label>
              Spotřeba kapaliny I
              <input
                type="text"
                value={`${totalConsumption} l`}
                readOnly
              />
            </label>

            <label>
              Spotřeba kapaliny II
              <input
                type="text"
                value={`${formData.type3FluidConsumption || 0} l`}
                readOnly
              />
            </label>

            <label>
              Spotřeba vody
              <input
                type="text"
                value={`${waterConsumption} l`}
                readOnly
              />
            </label>

            <label>
              Čas odmrazení
              <input
                type="text"
                value={`${deicingDurationMinutes} min`}
                readOnly
              />
            </label>

            {/* <label>
              Datum odmrazení
              <input
                type="date"
                value={
                  deicingDate
                    ? deicingDate.toISOString().split("T")[0]
                    : ""
                }
                readOnly
              />
            </label> */}
          </div>
        </section>

        {selectedDeicing && !operationCode && <section className="form-section">
          <h3>Systémové údaje</h3>

          <div className="form-grid">
            <label>
              Poslední úprava
              <DateTimeInput
                value={formData?.lastModified ? toLocalDateTime(formData.lastModified) : undefined}
                readOnly
              />
            </label>

            <label>
              Upravil
              <input type="text" value={formData?.modifiedByName} readOnly />
            </label>
          </div>
        </section>}

        {/* <div className="form-actions">
          <button type="submit">Uložit záznam</button>
        </div> */}

        <div className="item-list-actions">
          <FloatingActions actions={actions} />
        </div>

      </form>
    </Card>
  </>;
};

// interface DateTimeFieldProps {
//   label: string;
//   value: string | null;
//   onChange: (value: string) => void;
//   onSetCurrentTime: () => void;
// }

// const DateTimeField: React.FC<DateTimeFieldProps> = ({
//   label,
//   value,
//   onChange,
//   onSetCurrentTime,
// }) => (
//   <div className="date-time-field">
//     <label>
//       {label}
//       <input
//         type="datetime-local"
//         value={value ?? undefined /*toLocalDateTimeOffset(value) : undefined*/}
//         onChange={event => onChange(event.target.value)}
//       />
//     </label>

//     <button type="button" onClick={onSetCurrentTime}>
//       Nastavit aktuální čas
//     </button>
//   </div>
// );

interface DateTimeFieldProps {
  label: string;
  value: string | null;
  onChange: (value: string | null) => void;
  onSetCurrentTime: () => void;
  disabled?: boolean;
}

const DateTimeField: React.FC<DateTimeFieldProps> = ({
  label,
  value,
  onChange,
  onSetCurrentTime,
  disabled = false,
}) => {
  return (
    <div className="date-time-field">
      <div className="date-time-field__label">
        <span className="date-time-field__label-text">
          {label}
        </span>

        <DateTimeInput
          className="date-time-field__input"
          aria-label={label}
          value={value ?? ""}
          disabled={disabled}
          onChange={value => onChange(value || null)}
        />
      </div>

      <button
        className="date-time-field__button"
        type="button"
        disabled={disabled}
        onClick={onSetCurrentTime}
      >
        Nastavit aktuální čas
      </button>
    </div>
  );
};

interface NumberFieldProps {
  label: string;
  value: number | null;
  min?: number;
  max?: number;
  onChange: (value: number | null) => void;
  readOnly?: boolean;
}

const NumberField: React.FC<NumberFieldProps> = ({
  label,
  value,
  min,
  max,
  onChange,
  readOnly = false
}) => (
  <label>
    {label}
    <input
      type="number"
      value={value ?? undefined}
      min={min}
      max={max}
      step={1}
      onChange={event =>
        onChange(
          event.target.value === ""
            ? null
            : Number(event.target.value)
        )
      }
      readOnly={readOnly}
    />
  </label>
);

interface SelectFieldProps {
  label: string;
  value: string | number | null | undefined;
  options: Option[];
  onChange: (value: string) => void;
  disabled?: boolean;
}

const SelectField: React.FC<SelectFieldProps> = ({
  label,
  value,
  options,
  onChange,
  disabled = false
}) => (
  <label>
    {label}
    <select
      value={value ?? undefined}
      onChange={event => onChange(event.target.value)}
      disabled={disabled}
    >
      <option value="">Vyberte hodnotu</option>

      {options.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </label>
);

export default DeicingForm;

// import DeicingForm, {
//   DeicingFormData,
// } from "./DeicingForm";

// const App = () => {
//   const handleSubmit = (data: DeicingFormData) => {
//     console.log("Submitted data:", data);
//   };

//   return (
//     <DeicingForm
//       currentUserName="Martin Sommer"
//       stands={[
//         { value: "A1", label: "A1" },
//         { value: "A2", label: "A2" },
//         { value: "B1", label: "B1" },
//       ]}
//       companies={[
//         { value: "csa", label: "České aerolinie" },
//         { value: "smartwings", label: "Smartwings" },
//       ]}
//       weatherCodes={[
//         { value: "SN", label: "SN – sněžení" },
//         { value: "FZRA", label: "FZRA – namrzající déšť" },
//         { value: "FG", label: "FG – mlha" },
//       ]}
//       onSubmit={handleSubmit}
//     />
//   );
// };

// export default App;
